import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import AdminLayout from '@/layout/AdminLayout'
Vue.use(Router)

const requiresAuth = true;
const requiresAdmin = true;

export default new Router({
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      meta: {
        requiresAuth
      },
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard.vue')
        },
        {
          path: '/icons',
          name: 'icons',
          component: () => import(/* webpackChunkName: "dashboard" */ './views/Icons.vue')
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "dashboard" */ './views/UserProfile.vue')
        },
        {
          path: '/maps',
          name: 'maps',
          component: () => import(/* webpackChunkName: "dashboard" */ './views/Maps.vue')
        },
        {
          path: '/tables',
          name: 'tables',
          component: () => import(/* webpackChunkName: "dashboard" */ './views/Tables.vue')
        },
        {
          path: '/docs',
          name: 'docs',
          component: () => import(/* webpackChunkName: "dashboard" */ './views/Docs.vue')
        }
      ]
    },
    {
      path: '/admin',
      component: AdminLayout,
      meta: {
        requiresAuth,
        requiresAdmin
      },
      children: [
        {
          path: '',
          name: 'admin',
          component: () => import(/* webpackChunkName: "dashboard" */ './views/Admin.vue')
        },
        {
          path: 'users/:id?',
          name: 'admin-users',
          component: () => import(/* webpackChunkName: "dashboard" */ './views/Admin/Users.vue')
        }
      ]
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "common" */ './views/Login.vue')
        },
        {
          path: '/logout',
          name: 'logout',
          component: () => import(/* webpackChunkName: "common" */ './views/Logout.vue')
        },
        {
          path: '/register',
          name: 'register',
          component: () => import(/* webpackChunkName: "common" */ './views/Register.vue')
        }
      ]
    }
  ]
})
